import findAllFor from '../filters/find-all-for';

const getDragConstraintForElement = (element) => {
  const constraints = findAllFor(element);

  return constraints.find((constraint) => constraint.draggable);
};

export default getDragConstraintForElement;
